import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicCircleTenancyTenancyShorten({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 56 56"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <g fill="none" fillRule="evenodd">
        <circle fill="#666" opacity={0.92} cx={28} cy={28} r={28} />
        <rect fill="#999" x={15} y={15} width={26} height={26} rx={1} />
        <g fill="#FFF" fillRule="nonzero">
          <path d="M37.8 22.3a1 1 0 011.49 1.31l-.08.1L34.9 28l4.3 4.3a1 1 0 01.08 1.31l-.08.1a1 1 0 01-1.32.08l-.1-.08-5-5a1 1 0 01-.08-1.32l.08-.1 5-5z" />
          <path d="M43.5 28a1 1 0 01-1 1h-8v-2h8a1 1 0 011 1z" />
        </g>
        <g fill="#FFF" fillRule="nonzero">
          <path d="M18.2 22.3a1 1 0 00-1.49 1.31l.08.1L21.1 28l-4.3 4.3a1 1 0 00-.08 1.31l.08.1a1 1 0 001.32.08l.1-.08 5-5a1 1 0 00.08-1.32l-.08-.1-5-5z" />
          <path d="M21.5 27v2h-8a1 1 0 110-2h8z" />
        </g>
        <path fill="#FFF" fillRule="nonzero" d="M25 29h2v-2h-2zm4 0h2v-2h-2z" />
      </g>
    </svg>
  );
}

SvgPicCircleTenancyTenancyShorten.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicCircleTenancyTenancyShorten.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicCircleTenancyTenancyShorten svgRef={ref} {...props} />
));
export default ForwardRef;
